import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import Vant from "vant";
import "vant/lib/index.css";
import '../src/assets/style/index.scss'
import axios from "axios";
Vue.use(Vant);
Vue.config.productionTip = false;
Vue.prototype.$buildFullImageUrl = "https://gw.alicdn.com/tfscom/"
new Vue({
  axios,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
